import React, { useState } from 'react';
import { Box, Button, Modal} from '@mui/material';
import  SubmitCredentials from './SubmitCreds';
import { useNavigate } from 'react-router-dom';



const FormOpenAccount = ({onSuccess, email, password}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate(); 
 
  // const openModal = () => {
  //   setIsModalOpen(true);
  // };

  const closeModal = () => {
    setIsModalOpen(false);
  };


  return (
    <Box className="account-form" sx={{ zIndex: 900 }}>
      {!isModalOpen && (
        <Button
          variant="contained"
          color="primary"
          onClick={()=>{navigate('/signup', {
            state: { passEmail:email, passPassword: password }
          })}} // may be a permanent change we'll see
          // onClick={openModal}
        >
          Sign Up
        </Button>
      )}
      
      <Modal
        open={isModalOpen}
        onClose={closeModal}
        aria-labelledby="account-modal-title"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
      <SubmitCredentials onSuccess={onSuccess}
                          closeModal={closeModal}
      ></SubmitCredentials>
      </Modal>
    </Box>
  );
};

export default FormOpenAccount;
